import React from "react";

import { Link, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import Back from "assets/images/svg/back_blue.svg";
import ChangeIcon from "assets/images/svg/change_dark.svg";
import Addons from "assets/images/svg/addons_dark.svg";
import License from "assets/images/svg/license_dark.svg";
import Releases from "assets/images/svg/releases_dark.svg";
import Manage from "assets/images/svg/manage_dark.svg";
import Tab from "components/tabs/tabs";
import AddDevice from "./component/addDevice";
import { useModal } from "hooks";
import { useProduct } from "hooks/use-products";
import { json } from "helpers/data";
import { useTranslation } from "react-i18next";
import CanLoadGuard from "components/private-route/can-load.guard";

const MyApps = () => {
  const { t } = useTranslation("browse-apps");

  const [showSAddDevice, openAddDevice, closeAddDevice] = useModal(false);
  const { id } = useParams();
  const { search } = useLocation();
  const { product } = useProduct(id);
  return (
    <div className="settings myApps">
      <div className="header">
        <div className="page-name">
          <Link to="/my-products">
            <img src={Back} alt="back" />
          </Link>
          <h1>{json(product?.versionName)}</h1>
        </div>
        {search === "?device" && product?.usedDevice < product?.numberOfLicenses && (
            <CanLoadGuard>
          <div className="action">
            <button className="btn-green" onClick={openAddDevice}>
              + {t("myProducts.addDevice")}
            </button>
          </div>
            </CanLoadGuard>
        )}
      </div>
      <hr className="hr" />

      <div className="tabs">
        <div className="nav">
          <Tab
            url="licenses?device"
            title={`${t("myProducts.licensePage")} ${product?.usedDevice}/${product?.numberOfLicenses}`}
            img={License}
          />
          <Tab url="changeRequests" title={t("myProducts.changeRequestPage")} img={ChangeIcon} />
          <Tab url="addons" title={t("myProducts.addons")} img={Addons} />
          <Tab
            url="releases"
            title={t("myProducts.releases")}
            img={Releases}
            className={product?.newRelease > 0 ? "nav-link new-release" : "nav-link"}
          />
          <CanLoadGuard>
            <Tab url="Manage" title={t("myProducts.manage")} img={Manage} />
          </CanLoadGuard>
        </div>
      </div>

      <Outlet />
      <AddDevice show={showSAddDevice} onHide={closeAddDevice} />
    </div>
  );
};

export default MyApps;
